import { Instructor } from 'common/src/api/core/courses/types'
import React, { ReactElement } from 'react'
import { reusableCssClass } from '@/utils/reusableCssClasses'
import { AndrewImage } from '@/components/static/images/avatars/AndrewImage'
import { SeanImage } from '@/components/static/images/avatars/SeanImage'
import { MissingPersonImage } from '@/components/static/images/avatars/MissingPersonImage'
import { SueImage } from '@/components/static/images/avatars/SueImage'

interface InstructorData {
    prettyName: string
    imageComponent: ReactElement
    textContent: ReactElement
}

export const INSTRUCTOR_TO_INSTRUCTOR_DATA: Record<Instructor, InstructorData> =
    {
        [Instructor.andrew]: {
            prettyName: 'Andrew Gray',
            imageComponent: <AndrewImage />,
            textContent: (
                <>
                    <p>
                        Andrew completed his FSA in 2020,{' '}
                        <a
                            className={reusableCssClass.clickableTextUnderlined}
                            target={'_blank'}
                            href={
                                'http://www.actuarial-lookup.com/results/pnfbmr'
                            }
                            rel={'noreferrer'}
                        >
                            faster than the majority of his peers
                        </a>
                        , and has applied the key learnings from his successful
                        journey to building a comprehensive set of study
                        materials for the DP exam that are tailored to the
                        modern user.
                    </p>
                    <p>
                        Andrew has extensive educational experience, recognized
                        as being in the top 1% of private instructors on the{' '}
                        <a
                            className={reusableCssClass.clickableTextUnderlined}
                            target={'_blank'}
                            href={
                                'https://www.wyzant.com/Tutors/DataScienceByAndrew'
                            }
                            rel={'noreferrer'}
                        >
                            Wyzant platform
                        </a>
                        , with an average &#9733;&#9733;&#9733;&#9733;&#9733;
                        rating across thousands of hours working with a wide
                        variety of students.
                    </p>
                    <p>
                        He spent several years as a manager in the actuarial
                        department at Centene Corporation where he mentored
                        actuarial students, fostering their growth both
                        professionally and academically.
                    </p>
                    <p>
                        You can find him on LinkedIn{' '}
                        <a
                            className={reusableCssClass.clickableTextUnderlined}
                            target={'_blank'}
                            href={'https://www.linkedin.com/in/andrewjohngray/'}
                            rel={'noreferrer'}
                        >
                            here
                        </a>
                        .
                    </p>
                </>
            ),
        },
        [Instructor.sean]: {
            prettyName: 'Sean McMahon',
            imageComponent: <SeanImage />,
            textContent: (
                <>
                    <p>
                        Sean currently works as an actuary at Centene
                        Corporation, where he prices Individual Marketplace
                        products as part of the predictive modeling team.
                    </p>
                    <p>
                        Sean has always had a passion for education and sharing
                        his hard-earned knowledge with those around him. He is
                        incredibly responsive and is an integral part of all
                        health FSA exam content at JEP.
                    </p>
                    <p>
                        You can find him on LinkedIn{' '}
                        <a
                            className={reusableCssClass.clickableTextUnderlined}
                            target={'_blank'}
                            href={
                                'https://www.linkedin.com/in/sean-mcmahon-a62701183/'
                            }
                            rel={'noreferrer'}
                        >
                            here
                        </a>
                        .
                    </p>
                </>
            ),
        },
        [Instructor.sue]: {
            prettyName: 'Dr. Sue Jing',
            imageComponent: <SueImage />,
            textContent: (
                <>
                    <p>
                        Dr. Sue Jing Pharm.D M.S. is a registered pharmacist
                        with more than 15 years of experience in various
                        healthcare settings. She has been teaching pharmacy
                        technician certification courses since 2015. She enjoys
                        helping her students prepare for their pharmacy
                        technician career.
                    </p>
                </>
            ),
        },
        [Instructor.unassigned]: {
            prettyName: 'TBD',
            imageComponent: <MissingPersonImage />,
            textContent: <p>TBD</p>,
        },
    }

export const getPrettyNameForInstructor = (instructor: Instructor): string =>
    INSTRUCTOR_TO_INSTRUCTOR_DATA[instructor].prettyName

export const getImageComponentForInstructor = (
    instructor: Instructor
): ReactElement => INSTRUCTOR_TO_INSTRUCTOR_DATA[instructor].imageComponent

export const getTextContentForInstructor = (
    instructor: Instructor
): ReactElement => INSTRUCTOR_TO_INSTRUCTOR_DATA[instructor].textContent
